import CartCommon from '@/app-core/mixins/cart/cartCommon'
import OrderTimeEnum from '@/app-core/api/enums/OrderTimeEnum'
import CartActions from '@/app-core/mixins/cart/cartActions'

export default {
  name      : 'ScheduledOrder',
  components: {},
  directives: {},
  mixins    : [CartCommon, CartActions],
  props     : {},
  dataStore : {
    AppCart: 'App.Cart'
  },
  data() {
    return {
      scheduledOrder    : OrderTimeEnum.NOW,
      scheduledOrderDate: null,
      scheduledOrderTime: null
    }
  },
  computed: {
    OrderTimeEnum() {
      return OrderTimeEnum
    },
    scheduledOrderSubtitle() {
      return this.scheduledOrder === OrderTimeEnum.NOW
        ? `${this.cartStoresMinMaxTime} ${this.$tc('Common.Date.Minute', 0)}`
        : `${this.scheduledOrderDate ? this.scheduledOrderDate.Name : ''} ${this.scheduledOrderTime ? this.scheduledOrderTime.Name : ''}`
    },

    scheduledOrderDates() {
      const dates = []
      const config = {
        sameDay : `[${this.$t('Common.Date.Today')}]`,
        nextDay : `[${this.$t('Common.Date.Tomorrow')}]`,
        nextWeek: 'ddd, DD/MM',
        lastDay : 'DD/MM/YYYY',
        lastWeek: 'DD/MM/YYYY',
        sameElse: 'DD/MM/YYYY'
      }

      const minOrderMinutesAhead = this.AppConfig?.Marketplace?.ScheduledOrder?.MinimumOrderMinutesAhead ?? 30
      const timeNow = this.$dayjs().add(minOrderMinutesAhead, 'minute')

      for (let d = timeNow.isToday() ? 0 : 1; d < 5; d++) {
        const date = this.$dayjs().add(d, 'day')
        const obj = {
          Name : date.calendar(this.$dayjs(), config),
          Value: this.$dayjs(date).format('YYYY-MM-DD')
        }
        dates.push(obj)
      }

      return dates
    },
    scheduledOrderTimes() {
      const times = []
      const startTime = this.AppConfig?.Marketplace?.ScheduledOrder?.StartTime ?? 10
      const endTime = this.AppConfig?.Marketplace?.ScheduledOrder?.EndTime ?? 23
      const minOrderMinutesAhead = this.AppConfig?.Marketplace?.ScheduledOrder?.MinimumOrderMinutesAhead ?? 30
      const isTodaySelected = this.scheduledOrderDate?.Value === this.scheduledOrderDates[0]?.Value
      const timeNow = this.$dayjs().add(minOrderMinutesAhead, 'minute')
      const hourNow = isTodaySelected && timeNow.isToday() ? parseInt(timeNow.hour()) : startTime
      const minNow = isTodaySelected && timeNow.isToday() ? parseInt(timeNow.minute()) : minOrderMinutesAhead

      for (let h = hourNow; h < endTime; h++) {
        for (let m = 0; m < 60; m = m + 15) {
          if ((h === hourNow && m >= minNow && h >= startTime && h <= endTime) || (h > hourNow && h >= startTime && h <= endTime)) {
            //if ((h === hourNow && m >= minNow) || h > hourNow) {
            const hour = String(h).padStart(2, '0')
            const min = String(m).padStart(2, '0')
            const time = `${hour}:${min}`
            times.push({
              Name : time,
              Value: time
            })
          }
        }
      }

      return times
    }
  },
  watch: {
    scheduledOrder(newVal) {
      if (newVal === OrderTimeEnum.NOW) {
        this.scheduledOrderDate = null
        this.scheduledOrderTime = null
      } else {
        this.scheduledOrderDate = this.scheduledOrderDates[0] || null
        this.scheduledOrderTime = this.scheduledOrderTimes[0] || null
      }
    },

    scheduledOrderDate(newVal, oldVal) {
      this.$nextTick(() => {
        if (newVal) {
          if (newVal?.Value !== oldVal?.Value) {
            const scheduledOrderTimeIndex = this.scheduledOrderTimes.findIndex(item => item.Value === this.scheduledOrderTime?.Value)
            this.scheduledOrderTime = scheduledOrderTimeIndex > -1 ? this.scheduledOrderTimes[scheduledOrderTimeIndex] : this.scheduledOrderTimes[0] || null
          }
        } else {
          this.scheduledOrderTime = null
        }
      })
    },

    'AppCart.ScheduledOrder': {
      handler(newVal, oldVal) {
        this.updateValueFromModel()
      },
      immediate: true,
      deep     : true
    }
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    updateValueFromModel() {
      this.scheduledOrder = this.AppCart?.ScheduledOrder?.Type || OrderTimeEnum.NOW

      if (this.scheduledOrder === OrderTimeEnum.NOW) {
        this.scheduledOrderDate = null
        this.scheduledOrderTime = null

      } else {
        this.$nextTick(() => {
          const scheduledOrderDateIndex = this.scheduledOrderDates.findIndex(item => item.Value === this.AppCart?.ScheduledOrder?.Date)
          this.scheduledOrderDate = scheduledOrderDateIndex > -1 ? this.scheduledOrderDates[scheduledOrderDateIndex] : null

          const scheduledOrderTimeIndex = this.scheduledOrderTimes.findIndex(item => item.Value === this.AppCart?.ScheduledOrder?.Time)
          this.scheduledOrderTime = scheduledOrderTimeIndex > -1 ? this.scheduledOrderTimes[scheduledOrderTimeIndex] : null

          this.$nextTick(() => {
            if (!this.scheduledOrderDate || !this.scheduledOrderTime) {
              this.scheduledOrder = OrderTimeEnum.NOW
              this.setModelValue('updateValueFromModel')
            }
          })
        })
      }
    },

    setModelValue(t) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          const retVal = {
            Type    : this.scheduledOrder,
            Date    : this.scheduledOrder === OrderTimeEnum.NOW ? null : this.scheduledOrderDate?.Value || null,
            Time    : this.scheduledOrder === OrderTimeEnum.NOW ? null : this.scheduledOrderTime?.Value || null,
            DateTime: this.scheduledOrder === OrderTimeEnum.NOW ? null : this.scheduledOrderDate?.Value && this.scheduledOrderTime?.Value ? `${this.scheduledOrderDate.Value} ${this.scheduledOrderTime.Value}:00` : null
          }


          this.$nextTick(() => {
            if ((retVal.Type === OrderTimeEnum.NOW && !retVal.Date && !retVal.Time && !retVal.DateTime)
              || (retVal.Type === OrderTimeEnum.SCHEDULED && retVal.Date && retVal.Time && retVal.DateTime)
            ) {
              this.$emit('change', retVal)
              this.cartUpdateScheduled(retVal)
            }
          })
        })
      })
    }
  }
}
